/*
 * Copyright (c) 2024 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { ResponseEditConfig } from "../../models/submission-edit";
import { ResponseData } from "../../models/submission-edit";
import { ResponseEditData } from "../../models/submission-edit";
import { Observable } from "rxjs";
import { of } from "rxjs";
import { Injectable } from "@angular/core";
import { Type } from "@angular/core";
import { DavSubmissionAuthenticator } from "./zappsmith-dav/dav-authentication";
import { AuthenticatedForResponseData } from "../../models/submission-edit";

const _LEGACY_EDIT_KEY_ONLY_AUTH_STRAT = "edit_key_only"; // renamed to below
const EDIT_KEY_AS_TOKEN_AUTH_STRAT = "edit_key_as_token";
export const DEFAULT_AUTH_STRATEGY = EDIT_KEY_AS_TOKEN_AUTH_STRAT;

@Injectable()
export class EditKeyOnlySubmissionAuthenticator {
  authenticateAndGetData(
    editConfig: ResponseEditConfig
  ): Observable<AuthenticatedForResponseData> {
    return of({
      response_data: {
        response_data: (editConfig as ResponseEditData).response_data,
        client_data: (editConfig as ResponseEditData).client_data,
      },
    });
  }
}

@Injectable()
export class AppAuthenticationService {
  static providers(): Type<any>[] {
    return [
      AppAuthenticationService,
      EditKeyOnlySubmissionAuthenticator,
      DavSubmissionAuthenticator,
    ];
  }

  constructor(
    private editKeyAuth: EditKeyOnlySubmissionAuthenticator,
    private davAuth: DavSubmissionAuthenticator
  ) {}

  authenticateAndGetData(
    editConfig: ResponseEditConfig
  ): Observable<AuthenticatedForResponseData> {
    const authStrat = editConfig.auth_strategy ?? DEFAULT_AUTH_STRATEGY;
    if (
      authStrat === EDIT_KEY_AS_TOKEN_AUTH_STRAT ||
      authStrat === _LEGACY_EDIT_KEY_ONLY_AUTH_STRAT
    ) {
      return this.editKeyAuth.authenticateAndGetData(editConfig);
    } else if (authStrat === "zappsmith_dav") {
      return this.davAuth.authenticateAndGetData(editConfig);
    }
    throw new Error(`Unknown auth_strategy: ${authStrat}`);
  }
}
